<template>
  <div id="background" class="main-content">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6">
            <div class="text-center mb-4">
              <img
                class="navbar-brand-full p-3"
                src="@/assets/logo-w.svg"
                width="45%"
                alt="Expense Reduction Management Logo"
              />
            </div>
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="text-center mb-3">
                      {{ $t("PAGENOTFOUND") }}
                    </b-col>
                    <b-col cols="12" class="text-center">
                      <b-button variant="primary" to="/">{{
                        $t("HOME")
                      }}</b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.not-found{
  color : #FFFFFF !important;
}
</style>
